import React from "react";
import cx from "classnames";
import { useToggle, useLocalStorage } from "usehooks-ts";
import { ErrorBoundaryProvider } from "component-library";
import ProfileHeader from "pages/Profile/components/ProfileHeader";
import Gallery from "pages/Profile/components/GallerySection";
import RepsSection from "pages/Profile/components/RepsSection";
import BasicInfoSection from "pages/Profile/components/BasicInfoSection";
import SkillsSection from "pages/Profile/components/SkillsSection";
import TrainingSection from "pages/Profile/components/TrainingSection";
import CreditsSection from "pages/Profile/components/CreditsSection";
import SocialMediaSection from "pages/Profile/components/SocialMediaSection";
import MediaSection from "pages/Profile/components/MediaSection";
import Footer from "pages/Profile/components/common/Footer";
import "pages/Profile/styles.scss";

const profilePublicViewLSKey = "profilePublicView";

const Profile = () => {
  const [headExpanded, headToggle, setHeadValue] = useToggle();
  const [bodyExpanded, toggleBody, setBodyValue] = useToggle();
  const [isEdit, setIsEdit] = useLocalStorage(profilePublicViewLSKey, false);

  const toggleEdit = () => setIsEdit(!isEdit);

  const expandHeadToggle = () => {
    headToggle();
    setBodyValue(false);
  };

  const expandBodyToggle = () => {
    toggleBody();
    setHeadValue(false);
  };

  const clickHeadToggle = () => {
    if (!document.startViewTransition) {
      expandHeadToggle();

      return;
    }

    document.startViewTransition(() => {
      expandHeadToggle();
    });
  };

  const clickBodyToggle = () => {
    if (!document.startViewTransition) {
      expandBodyToggle();

      return;
    }

    document.startViewTransition(() => {
      expandBodyToggle();
    });
  };

  return (
    <ErrorBoundaryProvider>
      <div className="profile-page">
        <div className="profile-page-container">
          <ProfileHeader isEdit={isEdit} toggleEdit={toggleEdit} />
          <div
            className={cx("profile-page-grid", {
              "head-expanded": headExpanded === true,
              "body-expanded": bodyExpanded === true,
            })}
          >
            <div className="grid-item--head">
              <Gallery
                isHeadExpanded={headExpanded}
                toggleHeadExpanded={clickHeadToggle}
                isEdit={isEdit}
              />
              <RepsSection isEdit={isEdit} />
              <SocialMediaSection />
              <BasicInfoSection isEdit={isEdit} />
            </div>
            <div className="grid-item--body relative">
              <MediaSection
                isEdit={isEdit}
                clickBodyToggle={clickBodyToggle}
                bodyExpanded={bodyExpanded}
              />
              <CreditsSection isEdit={isEdit} />
            </div>
            <div className="grid-item--tail">
              <SkillsSection isEdit={isEdit} />
              <TrainingSection isEdit={isEdit} />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </ErrorBoundaryProvider>
  );
};

export default Profile;
